const HTTP: any = new Set()
const baseUrl = process.env.BASEURL

HTTP.BASEURL = `${baseUrl}/`

HTTP.LOGIN = `${baseUrl}/login`
HTTP.USER = `${baseUrl}/user/admin`
HTTP.EDIT_USER = `${baseUrl}/user/edit-info`
HTTP.EDIT_AGENT_INFO = `${baseUrl}/user/edit-agent-info`
HTTP.USER_CLIENT = `${baseUrl}/user/client`
HTTP.USERS_LIST = `${baseUrl}/user/admin-list`
HTTP.CLIENTS_LIST = `${baseUrl}/user/client-list`
HTTP.USER_GROUP = `${baseUrl}/client-group`
HTTP.ALL_AGENTS = `${baseUrl}/all-agents`
HTTP.AGENT = `${baseUrl}/user/agent`
HTTP.AGENT_INFO = `${baseUrl}/user/agent-info`
HTTP.FIND_USER_COMMISSION = `${baseUrl}/commissions/find-user`
HTTP.COMMISSIONS_CURRENT_MONTH = `${baseUrl}/commissions/current-month`
HTTP.GET_PRODUCTS = `${baseUrl}/commissions/get-products`
HTTP.GET_FILE = `${baseUrl}/commissions/clients-admin-file`
HTTP.ENQUEUE_FILE = `${baseUrl}/commissions/enqueue-clients-file`
HTTP.CREATE_COMMISSION_ROW = `${baseUrl}/commissions/create-commission-row`
HTTP.AGENT_CLIENTS = `${baseUrl}/agent/clients`
HTTP.SEND_PLUS_SUB_SMS = `${baseUrl}/agent/send-plus-sub-sms`
HTTP.INSTANT_AGENT_CLIENTS = `${baseUrl}/agent/search-clients`
HTTP.AGENT_CLIENT_COMMISSIONS = `${baseUrl}/agent/commissions`
HTTP.AGENT_COMMISSION_TOTALS = `${baseUrl}/agent/commissions-calculation`
HTTP.SUB_AGENT_COMMISSION = `${baseUrl}/agent/commissions/sub-agents`
HTTP.UPDATE_TOP_AGENT = `${baseUrl}/agent/top-agent`
HTTP.UPDATE_ADD_PORTFOLIO_MANAGER = `${baseUrl}/agent/add-portfolio-manager`
HTTP.UPDATE_COLLECTIVE = `${baseUrl}/agent/collective`
HTTP.UPDATE_MONTHLY_COMMISSION = `${baseUrl}/agent/monthly-commission`
HTTP.MENTORS = `${baseUrl}/mentor`
HTTP.MENTORS_FOR_PERIOD = `${baseUrl}/mentor/for-period`
HTTP.MENTORS_DASHBOARD = `${baseUrl}/mentor/dashboard`
HTTP.MENTORS_BUDGET = `${baseUrl}/mentor-budget`
HTTP.MENTORS_BUDGET_CREATE = `${baseUrl}/mentor-budget-create`
HTTP.UPDATE_MENTOR = `${baseUrl}/agent/update-mentor`
HTTP.MENTORS_MEETINGS_DASHBOARD = `${baseUrl}/mentor/meetings/dashboard`
HTTP.MENTORS_MEETINGS_BY_AGENT = `${baseUrl}/mentor/meetings/agent`
HTTP.MENTORS_MEETINGS_UNDOCUMENTED = `${baseUrl}/mentor/meetings/undocumented`
HTTP.MENTORS_MEETINGS_RECENT = `${baseUrl}/mentor/meetings/recent`
HTTP.MENTORS_MEETINGS_SEARCH_USER = `${baseUrl}/mentor/meetings/search-user`
HTTP.MENTORS_MEETINGS_EXPORT = `${baseUrl}/mentor/meetings/export`
HTTP.MENTORS_MEETINGS_EXPORT_RECENT = `${baseUrl}/mentor/meetings/export/recent`
HTTP.MENTORS_MEETINGS = `${baseUrl}/mentor/meetings`
HTTP.USER_HARB_CASES = `${baseUrl}/user/harb-cases`
HTTP.USER_ROLES = `${baseUrl}/user/user-data`
HTTP.PAYMENT_INFO = `${baseUrl}/payment-info`
HTTP.VERIFY_CODE = `${baseUrl}/user/verify-code`
HTTP.UPDATE_USER_HMO_PLANS = `${baseUrl}/user/update-hmo-plans`
HTTP.AUTHORIZED_PHONES = `${baseUrl}/agent/authorized-phones`
HTTP.INSURANCE_CASE_CLIENTS = `${baseUrl}/insurance-cases/clients`
HTTP.COMPANIES_LIST = `${baseUrl}/company/list`
HTTP.COMPANIES_HMO_LIST = `${baseUrl}/company/hmo-list`
HTTP.COMPANY = `${baseUrl}/company`
HTTP.GET_ALL_ROLES = `${baseUrl}/roles`
HTTP.UPDATE_USER_ROLES = `${baseUrl}/user/update-roles`

HTTP.USER_SEND_REQUEST = `${baseUrl}/user/users-request`

HTTP.COMMON_SETTINGS = `${baseUrl}/common-settings`

HTTP.POLICY_PARSER_USER_CASES = `${baseUrl}/policy-parser/user-cases`

HTTP.POLICY = `${baseUrl}/policy`
HTTP.POLICY_FIELD = `${baseUrl}/policy/field`
HTTP.POLICIES_LIST = `${baseUrl}/policy/list`
HTTP.SIMILAR_POLICIES_LIST = `${baseUrl}/policy/right-param-set`
HTTP.POLICY_PARENT_LIST = `${baseUrl}/policy/parent-list`
HTTP.POLICY_RIGHT_PARAM_SET = `${baseUrl}/policy/right-param-set`
HTTP.POLICY_COLLECTION_LIST = `${baseUrl}/policy-collection`
HTTP.POLICY_COLLECTION_ADD = `${baseUrl}/policy-collection/add`
HTTP.POLICY_COLLECTION_DELETE = `${baseUrl}/policy-collection/delete`
HTTP.POLICIES_BY_ID = `${baseUrl}/policy/by-id`
HTTP.RELEVANT_POLICIES = `${baseUrl}/policy/relevant`
HTTP.GROUP_POLICY_PROVIDER = `${baseUrl}/group-policy-provider`
HTTP.GROUP_POLICY_PROVIDER_LIST = `${baseUrl}/group-policy-provider/list`
HTTP.GROUP_POLICY_PROVIDER_PAIR_LIST = `${baseUrl}/group-policy-provider/pair-list`
HTTP.GROUP_POLICY_PROVIDER_POLICIES = `${baseUrl}/group-policy-provider/policies`
HTTP.GROUP_POLICY_PROVIDER_USERS = `${baseUrl}/group-policy-provider/users`
HTTP.NULL_POLICY = `${baseUrl}/policy/null-ins-case`
HTTP.PRODUCTS = `${baseUrl}/products`
HTTP.GRAPH_INFO = `${baseUrl}/info/graph`

HTTP.PRIVILEGE = `${baseUrl}/privilege`
HTTP.PRIVILEGES_LIST = `${baseUrl}/privilege/list`

HTTP.CATEGORY = `${baseUrl}/category`
HTTP.CATEGORIES_LIST = `${baseUrl}/category/list`
HTTP.CATEGORIES_REFS = `${baseUrl}/category/ref`

HTTP.COUPON_TYPE = `${baseUrl}/coupon/type`

HTTP.COUPON = `${baseUrl}/coupon`
HTTP.SURVEY_RESULTS = `${baseUrl}/survey-results`
HTTP.SURVEY_REFERENT_SCORES = `${baseUrl}/survey-results/referents`

HTTP.DOCTORS_LIST = `${baseUrl}/doctor/list`
HTTP.DOCTORS_SEARCH = `${baseUrl}/doctor/search`

HTTP.FILE = `${baseUrl}/files`
HTTP.FILES_LIST = `${baseUrl}/files/list`
HTTP.INVOICE = `${baseUrl}/invoice`
HTTP.COMMISSIONS = `${baseUrl}/commissions-files`
HTTP.COMMISSION_EXPORTS = `${baseUrl}/commission-export-files`
HTTP.COMMISSIONS_FROM_DB = `${baseUrl}/commissions-rows`
HTTP.MONTHLY_COMMISSION_FILE = `${baseUrl}/generate-monthly-commissions`
HTTP.UPDATE_AGENTS = `${baseUrl}/update-agents`
HTTP.GENERATE_PARENT_SUB = `${baseUrl}/generate-agents-sub-file`
HTTP.GENERATE_SMILE_SUB = `${baseUrl}/generate-smile-report`
HTTP.GENERATE_RDG_REPORT = `${baseUrl}/generate-rdg-report`
HTTP.GENERATE_AGE_SUB = `${baseUrl}/generate-active-subscribers-age-report`

HTTP.INSURANCE_CRAWLER_INIT_SEND_CODE = `${baseUrl}/insurance-crawler/init-send-code`
HTTP.INSURANCE_CRAWLER_AUTH_USER = `${baseUrl}/insurance-crawler/auth-user`

HTTP.INSURANCE_CALCULATOR = `${baseUrl}/service/insurance-calculator`
HTTP.COMPARE_POLICIES = `${baseUrl}/policy/compare`
HTTP.SHABAN_COMPARISONS = `${baseUrl}/info/shaban`

HTTP.RIGHT = `${baseUrl}/right`
HTTP.RIGHTS_LIST = `${baseUrl}/right/list`

HTTP.COLLECTIONS_LIST = `${baseUrl}/collection/list`
HTTP.COLLECTIONS_SEARCH = `${baseUrl}/collection/search`
HTTP.COLLECTION_TYPE = `${baseUrl}/collection/type`
HTTP.COLLECTION_TYPES = `${baseUrl}/collection/types`
HTTP.COLLECTION_CATEGORY = `${baseUrl}/collection/category`
HTTP.COLLECTION_SERVICEFIELD = `${baseUrl}/collection/servicefield`
HTTP.COLLECTION_CLINIC_SERVICES_LIST = `${baseUrl}/collection/collectionByClinic`
HTTP.COLLECTION = `${baseUrl}/collection`

HTTP.ES_LOG = `${baseUrl}/es-log`

HTTP.RECORDS_LIST = `${baseUrl}/record/list`

HTTP.PARAMETER = `${baseUrl}/parameter`
HTTP.PARAMETERS_LIST = `${baseUrl}/parameter/list`

HTTP.PARAM_GROUP = `${baseUrl}/param-group`
HTTP.PARAM_GROUP_LIST = `${baseUrl}/param-group/list`

HTTP.REGIONS = `${baseUrl}/regions`

HTTP.RIGHT_PARAMETER = `${baseUrl}/right-parameter`
HTTP.RIGHT_PARAMETER_LIST = `${baseUrl}/right-parameter/list`

HTTP.RIGHT_PARAM_SET = `${baseUrl}/right-param-set`
HTTP.RIGHT_PARAM_SET_LIST = `${baseUrl}/right-param-set/list`

HTTP.SERVICE_FIELD = `${baseUrl}/service-field`
HTTP.SERVICE_FIELDS_LIST = `${baseUrl}/service-field/list`

HTTP.SPECIALIZATIONS = `${baseUrl}/specializations`

HTTP.TERM = `${baseUrl}/term`
HTTP.TERM_COLLECTION = `${baseUrl}/term/collection`
HTTP.TERM_COLLECTION_LIST = `${baseUrl}/term/collection-list`
HTTP.TERM_FROM_COLLECTION = `${baseUrl}/term/from-collection`
HTTP.TERMS_LIST = `${baseUrl}/term/list`

HTTP.CLINIC = `${baseUrl}/clinic`
HTTP.CLINIC_SEARCH = `${baseUrl}/clinic/search`
HTTP.CLINIC_LIST = `${baseUrl}/clinic/list`
HTTP.CLINIC_SERVICES = `${baseUrl}/clinic-service`
HTTP.CLINIC_SERVICES_LIST = `${baseUrl}/clinic-service/list`
HTTP.SERVICE_CLINIC = `${baseUrl}/service_clinic`

HTTP.CITIES_LIST = `${baseUrl}/city/list`

HTTP.DRUG = `${baseUrl}/drug`
HTTP.DRUGS_LIST = `${baseUrl}/drug/list`
HTTP.DRUGS_ADD = `${baseUrl}/drug/listDrugCompaniesNoHealthRight`
HTTP.DRUGS_ADD_FAMILY = `${baseUrl}/group-drugs/add`
HTTP.DRUGS_DLT_FAMILY = `${baseUrl}/group-drugs/delete`
HTTP.DRUGS_DLT_RELATION = `${baseUrl}/drug-group-drugs/delete`
HTTP.DRUGS_ADD_RELATION = `${baseUrl}/drug-group-drugs/add`

HTTP.SYNONYM = `${baseUrl}/synonym`
HTTP.SYNONYMS_LIST = `${baseUrl}/synonym/list`
HTTP.SYNONYMS_SEARCH = `${baseUrl}/synonym/search`
HTTP.SYNONYMS_TERMS = `${baseUrl}/synonym/terms`

HTTP.VALID_TOKEN = `${baseUrl}/valid-token`

HTTP.SITE_CONTENT = `${baseUrl}/site_content`
HTTP.DLT_KEY_SITE_CONTENT = `${baseUrl}/site_content_dlt`
HTTP.SITE_CONTENT_ADD = `${baseUrl}/site_content_add`
HTTP.DLT_COMP_SITE_CONTENT = `${baseUrl}/site_content_comp_dlt`

HTTP.ADD_NEW_AGENCT = `${baseUrl}/agency`
HTTP.VALIDATE_LICENSE = `${baseUrl}/agent/agency-validate`

HTTP.SUBSCRIPTIONS = `${baseUrl}/subscriptions`
HTTP.FREEZE_SUB = `${baseUrl}/freeze-sub`
HTTP.UPDATE_SUB = `${baseUrl}/update-sub`
HTTP.ADD_SUB = `${baseUrl}/add-sub`
HTTP.UPDATE_SERVICE_PRICE = `${baseUrl}/update-service-price`
HTTP.CANCELED_SUB = `${baseUrl}/user-subscription/canceled-subscription`
HTTP.VALIDATE_COUPON_CODE = `${baseUrl}/coupon/validate`
HTTP.CHECK_DUPLICATE_PAYMENT = `${baseUrl}/user-subscription/check-duplicate-payment`
HTTP.USER_SUBSCRIPTION = `${baseUrl}/user-subscription`
HTTP.COLLECTIVE_SUBSCRIPTION = `${baseUrl}/user-subscription/collective`
HTTP.CANCELED_SPEC_SUB = `${baseUrl}/user-subscription/canceled-agent-subscription`
HTTP.TRANZILA_TRANSACTIONS = `${baseUrl}/tranzila/get-transactions`
HTTP.TRANZILA_TRANSACTIONS_SEARCH = `${baseUrl}/tranzila/transactions/search`
HTTP.TRANZILA_TRANSACTIONS_FILE = `${baseUrl}/tranzila/transactions-file`
HTTP.TRANZILA_TRANSACTION_PDF = `${baseUrl}/tranzila/transaction-pdf`
HTTP.TRANZILA_TRANSACTION_ITEMS = `${baseUrl}/tranzila/transaction-items`
HTTP.TRANZILA_DOCUMENTS = `${baseUrl}/tranzila/documents`
HTTP.TRANZILA_DOCUMENTS_FILE = `${baseUrl}/tranzila/documents-file`
HTTP.TRANZILA_DOCUMENTS_SKU_OPTIONS = `${baseUrl}/tranzila/documents/sku-options`
HTTP.TRANZILA_DOCUMENTS_PRODUCT_OPTIONS = `${baseUrl}/tranzila/documents/product-options`
HTTP.TRANZILA_DOCUMENTS_UNRESOLVED = `${baseUrl}/tranzila/documents/unresolved`
HTTP.UPDATE_BANK_APPROVAL = `${baseUrl}/update-bank-approval`
HTTP.UPDATE_SUBSCRIPTION_STATUS = `${baseUrl}/update-subscription-status`
HTTP.UPDATE_BLOCKED_CARD_SUBSCRIPTION_STATUS = `${baseUrl}/update-blocked-card-subscription-status`
HTTP.SUBSCRIPTION_HISTORY = `${baseUrl}/user-subscription/history`
HTTP.SUBSCRIPTION_RECOVERY = `${baseUrl}/subscription-recovery`
HTTP.SPECIAL_SUBSCRIPTION_HISTORY = `${baseUrl}/user-special-subscriptions/history`
HTTP.SPECIAL_SUBSCRIPTION_GR = `${baseUrl}/user-special-subscriptions/gr`
HTTP.CANCEL_SPECIAL_SUB = `${baseUrl}/user-special-subscriptions/cancel`
HTTP.FLY_EXPIRATION = `${baseUrl}/fly-expiration`
HTTP.USER_MESSAGES = `${baseUrl}/user-messages`

HTTP.FLY_REPORT = `${baseUrl}/user-special-subscriptions/fly-report`

HTTP.SERVICES_LIST = `${baseUrl}/services-list`
HTTP.FREEZE_SERVICE = `${baseUrl}/frz-services`
HTTP.ADD_SERVICE = `${baseUrl}/add-service`

HTTP.SPECIALIZATION_SPECIALITY = `${baseUrl}/specialization-speciality`

HTTP.HMO_COST = `${baseUrl}/policy/hmoComp`

HTTP.PRESET = `${baseUrl}/policy/preset`
HTTP.EMBEDDED = `${baseUrl}/embedded`

HTTP.STATISTICS = `${baseUrl}/info/statistics`

HTTP.SEARCH_WEIGHTS = `${baseUrl}/search/weights`

HTTP.INFO_MSG = `${baseUrl}/info-msg`
HTTP.INFO_MSG_TYPES = `${baseUrl}/info-msg/types`
HTTP.SMS_ADMIN = `${baseUrl}/sms/admin`
HTTP.UPDATE_PHONE = `${baseUrl}/user/admin/change-phone`

HTTP.SUB_AGENTS = `${baseUrl}/agent/sub-agents`
HTTP.SOLD_SUBS = `${baseUrl}/agent/sold-all`
HTTP.AGENTS_COMMISSIONS = `${baseUrl}/agent/agents-commissions`
HTTP.UPDATE_AGENT_PAYMENT = `${baseUrl}/agent/update-payment-commission`
HTTP.UPDATE_AGENT_FILE_ID = `${baseUrl}/agent/update-file-id-commission`
HTTP.UPDATE_AGENT_INVOICE_FILE_ID = `${baseUrl}/agent/update-invoice-file-id-commission`
HTTP.GET_AGENT_PAYMENTS = `${baseUrl}/agent/payments`
HTTP.UPDATE_AGENT_PAYMENTS = `${baseUrl}/agent/payments`
HTTP.GET_LAST_PAYMENT = `${baseUrl}/agent/payments/last-payment`
HTTP.PUBLISH_PAYMENTS = `${baseUrl}/agent/payments/publish-payments`
HTTP.PAY_AGENT_LIST = `${baseUrl}/agent/payments/pay-agent-list`
HTTP.CANCELLATION_REQUESTS = `${baseUrl}/cancellation-request`
HTTP.CANCELLATION_REQUESTS_EXPORT = `${baseUrl}/cancellation-request/export`
HTTP.CANCELLATION_REQUESTS_REPORT = `${baseUrl}/generate-cancellations-report`
HTTP.COMMISSIONS_FOR_CANCELLATION = `${baseUrl}/cancellation-request/commissions`
HTTP.SEND_CANCEL_MAIL = `${baseUrl}/cancellation-request/send-cancel-mail`
HTTP.UPDATE_PERCENTS = `${baseUrl}/agent/update-percents`
HTTP.UPDATE_ADVANCED_COMMISSION = `${baseUrl}/agent/advanced-commission`
HTTP.CREATE_MENTOR_COMMISSION = `${baseUrl}/mentor/commissions/single`
HTTP.DELETE_MENTOR_COMMISSION = `${baseUrl}/mentor/commissions/delete`
HTTP.EDIT_MENTOR_COMMISSION = `${baseUrl}/mentor/commissions/edit`
HTTP.MENTOR_COMMISSIONS_BY_AGENT_CLIENT = `${baseUrl}/mentor/commissions/agent-client`
HTTP.MENTOR_COMMISSIONS_BY_MONTH = `${baseUrl}/mentor/commissions/by-month`
HTTP.APPROVE_MENTOR_COMMISSIONS = `${baseUrl}/mentor/commissions/approve`
HTTP.EXPORT_MENTOR_COMMISSIONS = `${baseUrl}/mentor/commissions/export`
HTTP.MENTOR_COMMISSION_REPORTS = `${baseUrl}/mentor/commission-reports`
HTTP.MENTOR_COMMISSION_REPORT_FILE = `${baseUrl}/generate-mentor-commission-report`

HTTP.UNBLOCK_AGENT = `${baseUrl}/agent/unblock`
HTTP.BLOCK_AGENT = `${baseUrl}/agent/block`

HTTP.ADD_PAYMENT_LATE = `${baseUrl}/payment-late/add`
HTTP.EDIT_PAYMENT_LATE = `${baseUrl}/payment-late/edit`
HTTP.CLOSE_PAYMENT_LATE = `${baseUrl}/payment-late/close`
HTTP.GENERAL_OPTIONS = `${baseUrl}/services-list-admin`
HTTP.SERVICES_GENERAL = `${baseUrl}/services-general-admin`

HTTP.CHANGE_AGENT = `${baseUrl}/change-agent`

HTTP.MAIL_ADMIN = `${baseUrl}/email-crm-error`
HTTP.SMS_FINANCE = `${baseUrl}/sms/finance`

HTTP.CHECK_UNIQUE = `${baseUrl}/agent/check-unique`

HTTP.UPDATE_CLAIM = `${baseUrl}/claims/admin-update`
HTTP.USERS_CLAIM_TYPES = `${baseUrl}/claim-type/by-user`
HTTP.SAVED_CLAIM = `${baseUrl}/claims/saved-claim`

HTTP.FATHERS_NAME = `${baseUrl}/registration/hmo`

HTTP.SMALL_CLIENT_LIST = `${baseUrl}/user/small-client-list`
HTTP.DR_HOME_ORDER = `${baseUrl}/user/dr-home-order`

HTTP.GET_INVOICE_PERMIT = `${baseUrl}/permits/get-invoice`

HTTP.RESET_WHATSAPP_SESSION = `${baseUrl}/whatsapp/admin-reset-session`
HTTP.GET_WHATSAPP_STEPS = `${baseUrl}/whatsapp/all-steps`
HTTP.GET_OPEN_WHATSAPP_SESSIONS = `${baseUrl}/whatsapp/open-sessions`
HTTP.UPDATE_WHATSAPP_SESSION = `${baseUrl}/whatsapp/admin-update-session`
HTTP.DELETE_WHATSAPP_SESSION = `${baseUrl}/whatsapp/admin-delete-session`

HTTP.START_CAR_AGENT = `${baseUrl}/start-car/agent`
HTTP.START_CAR_AGENT_MESSAGE = `${baseUrl}/start-car/message/by-agent`
HTTP.START_CAR_MESSAGE = `${baseUrl}/start-car/message`

HTTP.SERVICE_DASHBOARD = `${baseUrl}/user-service/dashboard`

HTTP.GET_CLIENT_INVOICES = `${baseUrl}/client-invoices`
HTTP.GET_TRANZILA_INVOICE = `${baseUrl}/tranzila-invoice`

HTTP.CARD_STATUS = `${baseUrl}/user/card-status`
HTTP.UPDATE_CARD_STATUS = `${baseUrl}/user/update-card-status`

HTTP.CREATE_REPLACE_ROWS = `${baseUrl}/replaced-csv/create-replace-rows`
HTTP.REPLACED_APPLY_ACTIONS = `${baseUrl}/replaced-csv/apply-actions`
HTTP.REPLACED_LIST = `${baseUrl}/replaced-csv/list`
HTTP.REPLACED_HANDLE = `${baseUrl}/replaced-csv/handle`
HTTP.REPLACED_BATCH_STATUS = `${baseUrl}/replaced-batch-status`
HTTP.REPLACED_APPLY_REQUIRE_DATES = `${baseUrl}/replaced-csv/apply-require-dates`
HTTP.REPLACED_APPLY_REQUIRE_ROWS = `${baseUrl}/replaced-csv/apply-require-rows`

// ===TRANZILA BLOCK=== \\
HTTP.GET_STO_TRANZILA = `${baseUrl}/tranzila/client-sto`
HTTP.GET_STO_HISTORY = `${baseUrl}/tranzila/history-sto`
HTTP.GET_ALL_STO_HISTORY = `${baseUrl}/tranzila/history-all-sto`
HTTP.GET_STOS_LIST = `${baseUrl}/tranzila/stos-list`
HTTP.STO_LIST_FILE = `${baseUrl}/tranzila/sto-list-file`
HTTP.FIND_USER_DATA_FOR_STO = `${baseUrl}/tranzila/find-user-data-for-sto`
HTTP.UPD_STO_STATUS = `${baseUrl}/tranzila/upd-sto-status`
HTTP.UPD_SUB_ID_STO = `${baseUrl}/tranzila/upd-sub-id-sto`
HTTP.EDIT_SUB_STO_DATA = `${baseUrl}/tranzila/edit-sub-sto-data`
HTTP.STO_VERIFY = `${baseUrl}/tranzila/sto-verify`
HTTP.STO_CREATE = `${baseUrl}/tranzila/sto-create`
HTTP.STO_DEBIT = `${baseUrl}/tranzila/sto-debit`
HTTP.STO_BANK_CHARGE = `${baseUrl}/tranzila/sto-bank-charge`
HTTP.STO_BANK_DOCUMENT = `${baseUrl}/tranzila/sto-bank-document`
HTTP.CANCELED_SUB_TRANZILA = `${baseUrl}/tranzila/canceled-subscription-tranzila`
HTTP.UPDATE_STO_CREATED_AT = `${baseUrl}/tranzila/sto/update-sto-created-at`
HTTP.STO_DUPLICATES_STATUS = `${baseUrl}/tranzila/sto-duplicates/status`
HTTP.STO_DUPLICATES_RESOLVE = `${baseUrl}/tranzila/sto-duplicates/resolve`
// ===TRANZILA BLOCK=== \\

HTTP.MEDIWHO_APP_LECTURES = `${baseUrl}/mediwho-app/lectures`
HTTP.MEDIWHO_APP_NOTIFICATIONS = `${baseUrl}/mediwho-app/notifications`
HTTP.APP_BENEFITS = `${baseUrl}/mediwho-app/app-benefits`
HTTP.FLYERS = `${baseUrl}/flyers`
HTTP.CALLMARKER_CUSTOMERS = `${baseUrl}/call-marker/customers`

export default HTTP
